<template>

  <div class="marketing-email-form-models-section">
    <h1 class="marketing-email-form-models-section-title">{{ title }}</h1>

    <div class="marketing-email-form-models-section-body">
      <slot />
    </div>
  </div>

</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {},

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-form-models-section {
  margin-bottom: 30px;

  .marketing-email-form-models-section-title {
    color: #707070;
    font-size: 24px;
  }

  .marketing-email-form-models-section-body {
    display: flex;
    gap: 30px;
    flex-wrap: wrap;

    .marketing-email-form-models-section-body-item {
      flex-shrink: 0;
    }
  }
}
</style>

